import { render, staticRenderFns } from "./areaTpye.vue?vue&type=template&id=3410e5de&scoped=true"
import script from "./areaTpye.vue?vue&type=script&lang=js"
export * from "./areaTpye.vue?vue&type=script&lang=js"
import style0 from "./areaTpye.vue?vue&type=style&index=0&id=3410e5de&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410e5de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3410e5de')) {
      api.createRecord('3410e5de', component.options)
    } else {
      api.reload('3410e5de', component.options)
    }
    module.hot.accept("./areaTpye.vue?vue&type=template&id=3410e5de&scoped=true", function () {
      api.rerender('3410e5de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/scenic-spot/components/areaTpye.vue"
export default component.exports